<rt-dialog-header
  [heading]="dialogData.partnerName"
  [subheading]="'rti.common.settings.legal_dialog.subheading' | translate"
>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rt-heading margin-bottom-small-x>
    {{ dialogData.textOverClaims }}
  </rt-heading>
  <rt-integration-list-legal-dialog-content
    [claimsHeading]="dialogData.claimsHeading"
    [claimsList]="dialogData.claims"
    [textUnderClaims]="dialogData.textUnderClaims"
    [listType]="dialogData.listType"
  ></rt-integration-list-legal-dialog-content>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button variant="primary" (click)="accept()">
    {{ dialogData.buttonText }}
  </rt-button>
</rt-dialog-footer>
